import PropTypes from 'prop-types';
export var chevronAlignProptypes = PropTypes.oneOf(['left', 'right', 'none']);